import React from "react";
import { useSelector } from "react-redux";
import Styles from "./ConGenMain.module.css";
import SelfHeader from "./HeadingElements/SelfHeader";
import SelfListing from "./ListingContainer/SelfListing/SelfListing";
import AvailableListingContainer from "./ListingContainer/AvailableListing/AvailableListingContainer";
import DamStrip from "../Modals/ConGen/Connection/DamStrip";

const ConGenMain = () => {
  const userType = useSelector((state) => state?.persistedReducer?.userType);
  const showDamStrip = userType === "CONSUMER" || userType === "GENERATOR";

  return (
    <div className={Styles.outerWrapper}>
      {/* {showDamStrip && <DamStrip />} */}
      <div className={Styles.congenMainCont}>
        <div>
          <div className={Styles.elemHeader}>
            <SelfHeader />
          </div>
          <div className={`scroll_bar_x ${Styles.selfListingContainer}`}>
            <SelfListing />
          </div>
        </div>
        <div
          style={{
            maxHeight: "calc(100vh - 97px)",
            overflowY: "auto",
            position: "relative",
          }}
        >
          <AvailableListingContainer />
        </div>
      </div>
    </div>
  );
};

export default ConGenMain;
